import { AnimatePresence } from 'framer-motion'
import { Field, Formik } from 'formik'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withNullErrorBoundary } from '../../../../utils'
import { motion } from '../../../motion'
import { object, string } from 'yup'
import { setDeliveryPhoneNumber } from '../../../../store/reducers/slices/checkout'
import FormLabel from '../../../form/form-label'
import { ErrorMessage } from '../../checkout-step-1'

const ShippingNotifications = () => {
  const show = useSelector(state => state.checkout.form.shippingNotificationsEnabled)

  return (
    <motion.div>
      <AnimatePresence initial={false}>
        {show && (
          <motion.div
            layout
            key="billing-address"
            variants={{
              open: { height: 'auto', opacity: 1 },
              closed: { height: 0, opacity: 0 },
            }}
            initial="closed"
            animate="open"
            exit="closed"
            transition={{ type: 'spring', stiffness: 200, damping: 25 }}
          >
            <div
              className="address--billing"
            >
              <ShippingNotificationsForm />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>

  )
}

const ShippingNotificationsFormSchema = object().shape({
  phoneNumber: string()
    .matches(/^\s*(\d\s*){8,10}$/, 'Invalid format')
    .trim()
    .required('Required'),
})

const ShippingNotificationsForm = () => {
  const initialPhone = useSelector(state => state.checkout.form.phoneNumber)
  const dispatch = useDispatch()

  if(initialPhone) {
    dispatch(setDeliveryPhoneNumber(initialPhone))
  }

  const initialValues = {
    phoneNumber: initialPhone || '',
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      validationSchema={ShippingNotificationsFormSchema}
    >
      {({ handleChange }) => (
        <div className="p-0 form-group">
          <FormLabel htmlFor="phoneNumber" title="Phone Number" className="required" />
          <Field
            id="phoneNumber"
            name="phoneNumber"
            autoComplete="off"
            className="form-control"
            type="text"
            onChange={(e) => {
              handleChange(e)
              dispatch(setDeliveryPhoneNumber(e.target.value))
            }}
          />
          <ErrorMessage name="phoneNumber" />
        </div>
      )}
    </Formik>
  )
}

export default withNullErrorBoundary(ShippingNotifications)
